/* global WebSocket */
import { WS_ACTION_TYPES } from '../actionTypes';
import environment from '../../environment';

const { wsUrl } = environment;

// reducer with initial state
const initialState = {
  ws: {},
  ws_error: null,
};

const connectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case WS_ACTION_TYPES.WS.INIT:
      return { ...state, ws: new WebSocket(wsUrl), ws_error: null };
    case WS_ACTION_TYPES.WS.ERROR:
      return { ...state, ws: {}, ws_error: 'Error on connection' };
    default:
      return state;
  }
};

export default connectionReducer;
